module.exports = __webpack_public_path__ + "static/media/wheel.8e9850a9.png";